import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/core/api.service';
import { LoggerService } from 'src/app/core/logger.service';
import { UserService } from 'src/app/core/user.service';
import { ErrCode, User } from 'src/app/shared/models';


@Component({
  templateUrl: './account-hold.component.html',
  styleUrls: ['./account-hold.component.scss'],
})
export class AccountHoldComponent implements OnInit {
  protected user: User;
  userId: number;
  plan: number;
  signature: string;
  public isChild: boolean;
  protected errCode: ErrCode;
  protected isLoading: boolean = false;

  constructor(
    private userService: UserService,
    private route: ActivatedRoute,
    private apiService: ApiService,
    private loggerService: LoggerService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.user = this.userService.getUser();
    this.isChild = (this.route.snapshot.queryParams['type'] == 'childuser');
    this.route.queryParams.subscribe(params => {
      this.userId = +params['user']; 
      this.plan = +params['p'];  
      this.signature = params['sig'];
    });
  }

  protected get lockMessage() {
    return 'Your account is on hold.';
  }

  // UI handlers
  protected onClickRenew = async () => {
    try {
      this.isLoading = true;
      const user_id = this.route.snapshot?.queryParams?.user;
      const result = await this.apiService.execute('getchargebeerenewurl', {
        user_id,
        type: 'renew'
      }) as any;
      window.location.href = result.renew_url;
    } catch (error) {
      this.loggerService.error(error);
      this.errCode = ErrCode.fromException(error);
    } finally {
      this.isLoading = false;
    }
  }
  
  protected onClickBackToSignIn = () => {
    this.router.navigateByUrl('/login');
  }
}